import { render, staticRenderFns } from "./GlobalSearchList.vue?vue&type=template&id=a85a5296&"
import script from "./GlobalSearchList.vue?vue&type=script&lang=ts&"
export * from "./GlobalSearchList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports